let language = {
    PHOTO_LIB_LIST_DELET_TITLE: "Delete Card Rarity",
    PHOTO_LIB_LIST_DELET_CONTENT: "Are you sure you want to delete the card rarity? Deleting this Card Rarity will reset random draw rules.",
    PHOTO_LIB_LIST_DELET_ISSUE_TITLE: "Delete Card Rarity Failed",
    PHOTO_LIB_LIST_DELET_ISSUE_CONTENT: "Oops! The rare card library couldn’t be deleted. Please retry or check your connection.",

}
export { language }